import { SET_PAGE } from "constants/ActionTypes";
import { INITIAL_STATE } from "constants/AppConstants";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PAGE:
      return { ...state, rentalBoardPages: action.payload };
    default:
      return state;
  }
};
